// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "core.ruffle." + {"482":"e3141da25d3b8edcc827","655":"107e3154e774323e0b1f"}[chunkId] + ".js";
};